import { Field as KandaField } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';

interface FieldProps {
  fieldName?: string;
  label?: string;
  validationMessage?: string;
}

const Field = ({ label, validationMessage, fieldName }: FieldProps) => (
  <div className="flex w-full">
    <KandaField.Validator
      validation={{
        required: {
          value: true,
          message: validationMessage as string,
        },
      }}
    >
      <KandaField.BooleanInput
        name={fieldName}
        handle="checkbox"
        fieldText={<Text text={label} />}
      />
    </KandaField.Validator>
  </div>
);

Field.defaultProps = {
  fieldName: 'acceptedDisclaimer',
  label: 'I have read and understood the above disclaimer',
  validationMessage:
    'You must have read, understood and agree to the above disclaimer',
};

export default Field;
